import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/css/custom.css";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from "@apollo/client";
import { onError } from "apollo-link-error";
import NotFound from "views/NotFound";
import Activation from "views/Activation";
import CustomCheckout from "views/CustomCheckout";
import Confirmation from "views/Confirmation";
import ProtectedRoute from "components/custom/protectedroute";
import Login from "views/Login";
import AuthProvider from "components/custom/authprovider";
import Logout from "views/Logout";
import Register from "views/Register";
import VerifyCard from "views/VerifyCard";
import LinkPlaid from "views/LinkPlaid";
import Profile from "views/Profile";
import AdminHome from "views/admin/AdminHome";
import AdminLogin from "views/admin/AdminLogin";
import TransactionLookup from "views/admin/TransactionLookup";
import CustomerLookup from "views/admin/CustomerLookup";
import GenerateReceipt from "views/admin/GenerateReceipt";
import PrintInvoice from "views/admin/PrintInvoice";
import PrintReceipt from "views/admin/PrintReceipt";
import TransactionDisputeLookup from "views/admin/TransactionDisputeLookup";
import LockNotesLookup from "views/admin/LockNotesLookup";
import UserManagement from "views/admin/UserManagement";
import FixTransaction from "views/FixTransaction";
import ProcessorStatusReport from "views/admin/ProcessorStatusReport";

const BaseURL =
  process.env.REACT_APP_APIURL + ":" + process.env.REACT_APP_SERVERPORT;

let HttpURL;

if (process.env.REACT_APP_APIURL === "localhost") {
  HttpURL = "http://" + BaseURL + "/graphql";
} else {
  HttpURL = "https://" + BaseURL;
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log("graphQLErrors", graphQLErrors);
  }
  if (networkError) {
    console.log("networkError", networkError);
  }
});

const finalLink = from([
  errorLink,
  new HttpLink({ uri: HttpURL, credentials: "include" }),
]);

const client = new ApolloClient({
  link: finalLink,
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <Switch>
        <Route path="/admin">
          <AuthProvider admin={true}>
            <Switch>
              <Route
                exact
                path="/admin"
                render={(props) => (
                  <ProtectedRoute
                    {...props}
                    Component={AdminHome}
                    admin={true}
                  />
                )}
              />

              <Route path="/admin/tools">
                <Switch>
                  <Route
                    exact
                    path="/admin/tools/transaction-lookup"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={TransactionLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/transaction-lookup/:ctransactionid"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={TransactionLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/transaction-dispute-lookup"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={TransactionDisputeLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/transaction-dispute-lookup/:cphone"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={TransactionDisputeLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/locknote-lookup"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={LockNotesLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/locknote-lookup/:cphone"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={LockNotesLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/customer-lookup"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={CustomerLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/customer-lookup/:cphone"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={CustomerLookup}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/generate-receipt"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={GenerateReceipt}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/generate-receipt/:ctransactionid"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={GenerateReceipt}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/user-management"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={UserManagement}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/tools/user-management/:userPhone"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={UserManagement}
                        admin={true}
                      />
                    )}
                  />

                  <Route path="*" render={() => <NotFound />} />
                </Switch>
              </Route>

              <Route path="/admin/reports">
                <Switch>
                  <Route
                    exact
                    path="/admin/reports/all-transactions"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={AdminHome}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/payments"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={AdminHome}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/processor-status"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={ProcessorStatusReport}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/customer-processor-status"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={AdminHome}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/processor-projection"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={AdminHome}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/transaction/:ctransactionid/print-invoice"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={PrintInvoice}
                        admin={true}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/reports/transaction/:ctransactionid/print-receipt"
                    render={(props) => (
                      <ProtectedRoute
                        {...props}
                        Component={PrintReceipt}
                        admin={true}
                      />
                    )}
                  />

                  <Route path="*" render={() => <NotFound />} />
                </Switch>
              </Route>

              <Route path="/admin/login" render={() => <AdminLogin />} />
              <Route path="/admin/logout" render={() => <Logout />} />
              <Route path="*" render={() => <NotFound />} />
            </Switch>
          </AuthProvider>
        </Route>

        <Route path="/">
          <AuthProvider>
            <Switch>
              <Route
                path="/checkout/:productid"
                render={(props) => (
                  <ProtectedRoute {...props} Component={CustomCheckout} />
                )}
              />
              <Route
                path="/verifyaccount"
                render={(props) => (
                  <ProtectedRoute {...props} Component={LinkPlaid} />
                )}
              />
              <Route
                path="/verifycard"
                render={(props) => (
                  <ProtectedRoute {...props} Component={VerifyCard} />
                )}
              />
              <Route
                path="/profile"
                render={(props) => (
                  <ProtectedRoute {...props} Component={Profile} />
                )}
              />

              <Route
                path="/util/5b150003-994d-4b7a-89b3-2eba3fd392c8/fix-wowwc"
                render={() => <FixTransaction />}
              />

              <Route path="/register" render={() => <Register />} />
              <Route path="/login" render={() => <Login />} />
              <Route path="/logout" render={() => <Logout />} />
              <Route path="/confirmation" render={() => <Confirmation />} />
              <Route path="/activation" render={() => <Activation />} />
              <Route path="*" render={() => <NotFound />} />
            </Switch>
          </AuthProvider>
        </Route>
      </Switch>
    </BrowserRouter>
  </ApolloProvider>,
);
